import { render, staticRenderFns } from "./unmatched-deposit.vue?vue&type=template&id=6f952ffa&"
import script from "./unmatched-deposit.vue?vue&type=script&lang=js&"
export * from "./unmatched-deposit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports